var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.configuration)?_c('div',{staticClass:"lesson"},[_vm._l((_vm.contents),function(page,index){return [_c('div',{staticClass:"page"},[_c('resource',{attrs:{"content":page}})],1),_c('div',{staticClass:"flex flex-center page-number"},[_c('div',{staticClass:"badge"},[_vm._v("Page "+_vm._s(index + 1))])])]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }